import script from "./RedProductRequestPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./RedProductRequestPopup.vue?vue&type=script&setup=true&lang=ts"

import "./RedProductRequestPopup.vue?vue&type=style&index=0&id=0df99da0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df99da0"]])

export default __exports__